import useSWR from 'swr';

import { Breadcrumb } from 'components/Breadcrumb';
import { PageHeader } from 'components/PageHeader';
import { PageHeading } from 'components/PageHeading';
import { SpinnerBlock } from 'components/Spinner';
import { useTranslation } from 'contexts/translation-context';
import { useDownloadDocument } from 'src/app/document/hooks/useDownloadDocument';
import { getCarrierPortalKnowledgeBase } from '../models';
import { useCarrierPortalSupplier } from '../CarrierPortalCarrierContext';
import { ErrorState } from 'components/error-state/ErrorState';

export const CarrierPortalKnowledgeBasePage = () => {
  const { i18n } = useTranslation();
  const { carrierId } = useCarrierPortalSupplier();
  const { downloadFile } = useDownloadDocument();

  const {
    data: docs,
    error,
    isLoading,
    mutate,
  } = useSWR(['carrier-portal-knowledge-base', carrierId], () => getCarrierPortalKnowledgeBase(carrierId));

  return (
    <div>
      <PageHeader title={i18n('carrierPortal.generalInformation.generalInformation')} />

      <PageHeading
        leftSide={<Breadcrumb currentItem={i18n('carrierPortal.generalInformation.generalInformation')} />}
      />

      <div className="px-4 pb-8">
        {error ? (
          <ErrorState error={error} onRetry={() => mutate()} variant="section" />
        ) : isLoading || !docs ? (
          <SpinnerBlock message={i18n('carrierPortal.loading')} />
        ) : (
          <div className="space-y-4">
            {docs.length === 0 ? (
              <div className="text-center py-12">
                <div className="text-fg-muted text-lg mb-2">
                  {i18n('carrierPortal.generalInformation.noDocumentsAvailable')}
                </div>
                <div className="text-fg-muted text-sm">{i18n('carrierPortal.generalInformation.checkBackLater')}</div>
              </div>
            ) : (
              <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
                {docs.map((doc) => (
                  <div
                    key={doc.id}
                    className="card font-medium p-4"
                    data-clickable="true"
                    onClick={async () => {
                      await downloadFile(doc.document);
                    }}
                  >
                    {doc.name || doc.document.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
